import { typography } from '@joor/design-system'
import styled from 'styled-components/macro'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  // this is needed in order to make the overlay clickable
  // due to the ag-grid overlay is set to pointer-events: none
  pointer-events: auto;
  max-width: 512px;
`

export const Header = styled.h2`
  margin: 0 !important;
  font-family: Montserrat !important;
  font-size: 16px !important;
  font-style: normal;
  font-weight: 500 !important;
  line-height: 20px !important;
  letter-spacing: 1.4px;
  color: var(--color-primary-800);
`

export const Body = styled.p`
  ${typography.alpha.primaryActive.body3}
  color: var(--color-primary-400);
`
